import ro from "../util/browser-detector.js";
import Jt from "../models/device.js";
import DeviceProperties from "../Core/device-properties.js";
import _t from "../models/identifier.js";
import { logger as E, Guid as P } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { values as Pt } from "../util/code-utils.js";
import { getErrorMessage as ai } from "../util/error-utils.js";
export default class Ot {
  constructor(t, e) {
    (this.B = t),
      (this.tc = e),
      (this.B = t),
      null == e && (e = Pt(DeviceProperties)),
      (this.tc = e);
  }
  ve(t = !0) {
    let e = this.B.$u(s.Ou.tl);
    null == e && ((e = new _t(P.se())), t && this.B.Iu(s.Ou.tl, e));
    const r = new Jt(e.Tu);
    for (let t = 0; t < this.tc.length; t++) {
      switch (this.tc[t]) {
        case DeviceProperties.BROWSER:
          r.browser = ro.browser;
          break;
        case DeviceProperties.BROWSER_VERSION:
          r.ec = ro.version;
          break;
        case DeviceProperties.OS:
          r.os = this.rc();
          break;
        case DeviceProperties.RESOLUTION:
          r.sc = screen.width + "x" + screen.height;
          break;
        case DeviceProperties.LANGUAGE:
          r.language = ro.language;
          break;
        case DeviceProperties.TIME_ZONE:
          r.timeZone = this.oc(new Date());
          break;
        case DeviceProperties.USER_AGENT:
          r.userAgent = ro.userAgent;
      }
    }
    return r;
  }
  rc() {
    if (ro.nc()) return ro.nc();
    const t = this.B.dt(s.ft.ac);
    return t && t.os_version ? t.os_version : ro.rc();
  }
  oc(t) {
    let e = !1;
    if ("undefined" != typeof Intl && "function" == typeof Intl.DateTimeFormat)
      try {
        if ("function" == typeof Intl.DateTimeFormat().resolvedOptions) {
          const t = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (null != t && "" !== t) return t;
        }
      } catch (t) {
        E.info(
          "Intl.DateTimeFormat threw an error, cannot detect user's time zone:" +
            ai(t),
        ),
          (e = !0);
      }
    if (e) return "";
    const r = t.getTimezoneOffset();
    return this.cc(r);
  }
  cc(t) {
    const e = Math.trunc(t / 60),
      r = Math.trunc(t % 60);
    let s = "GMT";
    return (
      0 !== t &&
        ((s += t < 0 ? "+" : "-"),
        (s +=
          ("00" + Math.abs(e)).slice(-2) +
          ":" +
          ("00" + Math.abs(r)).slice(-2))),
      s
    );
  }
}
